import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';

import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF, EXPORT_TEXT } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import {
  INVENTORY_WAREHOUSE_SELECTOR_PROPS,
  DATE_RANGE_PROPS,
  INVENTORY_SPECIFIC_SKU_PROPS,
} from '../../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_TEXT, EXPORT_CSV];

const filtersProps = [INVENTORY_WAREHOUSE_SELECTOR_PROPS, DATE_RANGE_PROPS, INVENTORY_SPECIFIC_SKU_PROPS];

const InventoryAuditReport = () => {
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default InventoryAuditReport;
